<template>
  <div id="app">
    <div v-if="$store.getters.appLoaded">
      <router-view/>
      <div id="cookies-banner" v-bind:class="{ active: showCookies }">
        <div class="cookies-banner-text">
          <div v-html="$store.getters.getData.cookies_banner"></div>
          <a @click="acceptCookies" class="waves-effect waves-light btn-small">{{ $i18n.t('GENERAL.ACCEPT') }}</a>
        </div>
      </div>
    </div>
    <div v-else id="loader">
      <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
    </div>
  </div>
</template>

<script>
import Navbar from './components/Navbar.vue'
import SpatialNavigation from 'js-spatial-navigation'
import M from 'materialize-css'
const auth = require('@/services/auth.js')

export default {
  name: 'app',
  components: {
    'nav-bar': Navbar
  },
  // beforeCreate: function () {
  //   const localeBrowser = navigator.language || navigator.userLanguage
  //   if (localeBrowser in this.$i18n.messages) this.$i18n.locale = localeBrowser
  // },
  created: function () {
    // LOOAD APP
    auth.initApp(false).then((response) => {
      auth.getClient().then(() => {
        auth.getUser().then(response => {
          this.$store.commit('setUser', response.data['results'][0])
        })
      })
    })
  },
  mounted () {
    SpatialNavigation.init()

    // desactivamos navegación espacial
    if (this.$store.getters.platform === 'browser') {
      window.SpatialNavigation.focus = function () { return true }
    }

    // mouse wheel
    document.addEventListener('wheel', (e) => {
      e.wheelDelta < 0 ? SpatialNavigation.move('down') : SpatialNavigation.move('up')
    })
    // NETWORK
    window.addEventListener('online', () => {
      M.toast({html: this.$i18n.t('NETWORK.OK'), classes: 'green lighten-1'})
    })
    window.addEventListener('offline', () => {
      M.toast({html: this.$i18n.t('NETWORK.KO'), classes: 'red lighten-1'})
    })
  },
  methods: {
    acceptCookies () {
      localStorage.setItem('acceptCookies', 'true')
      document.getElementById('cookies-banner').classList.remove('active')
    }
  },
  computed: {
    showCookies () {
      return localStorage.getItem('acceptCookies') !== 'true' && this.$store.getters.getData.cookies_banner
    }
  }
}
</script>

<style lang="sass" scoped>
#app
  width: 100vw;
  min-height: 100vh;
  color: #373a3c;

// loader
#loader
  position: absolute;
  width: 100%;
  min-height: 100%;

  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url("./assets/images/splash.jpg");

  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-end;

  .lds-ring
    display: inline-block;
    position: relative;
    width: 64px;
    height: 64px;
    padding-bottom: 15rem;

  .lds-ring div
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 5rem;
    height: 5rem;
    margin: 6px;
    border: 6px solid #fff;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #fff transparent transparent transparent;

  .lds-ring div:nth-child(1)
    animation-delay: -0.45s;

  .lds-ring div:nth-child(2)
    animation-delay: -0.3s;

  .lds-ring div:nth-child(3)
    animation-delay: -0.15s;

  @keyframes lds-ring
    0%
      transform: rotate(0deg);

    100%
      transform: rotate(360deg);

#cookies-banner
  position: fixed
  top: 0
  left: 0
  right: 0
  bottom: 0
  z-index: 9999
  background-color: rgba(0, 0, 0, 0.7);

  display: none

  &.active
      display: block!important

  .cookies-banner-text
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: #000

    padding: .6rem 4rem
    color: #D1D1D1
    font-size: .6rem

    a
      float: right;

</style>



// WEBPACK FOOTER //
// src/App.vue